import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { lookbookCollections } from '../data/lookbookData';
export function Lookbook() {
  return <div className="bg-white min-h-screen pt-32 pb-20 px-6" data-id="element-603">
      <div className="max-w-[1800px] mx-auto" data-id="element-604">
        <header className="mb-20 text-center" data-id="element-605">
          <span className="text-xs md:text-sm font-display font-bold uppercase tracking-[0.3em] md:tracking-[0.5em] mb-6 block text-black/50" data-id="element-606">
            Editorial
          </span>
          <h1 className="text-xl sm:text-4xl md:text-6xl font-display font-bold tracking-[0.05em] md:tracking-[0.2em] uppercase mb-6" data-id="element-607">
            The Lookbook
          </h1>
          <p className="max-w-xl mx-auto text-sm md:text-base font-light tracking-widest text-black/60 leading-relaxed uppercase px-4 md:px-0" data-id="element-608">
            Explore the movement, texture, and cultural narrative of Djily
            Creations. Click a model to view the full editorial.
          </p>
        </header>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1" data-id="element-609">
          {lookbookCollections.map((collection, idx) => <Link to={`/lookbook/${collection.id}`} key={collection.id} data-id="element-610">
              <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: idx * 0.1
          }} className="relative aspect-[3/4] group cursor-pointer overflow-hidden bg-grey-divider" data-id="element-611">
                <img src={collection.image} alt={collection.title} className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110" data-id="element-612" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-500" data-id="element-613" />

                <div className="absolute top-6 left-6 text-white" data-id="element-614">
                  <span className="text-xs font-display font-bold tracking-[0.3em] uppercase opacity-80" data-id="element-615">
                    Featuring
                  </span>
                  <p className="text-sm md:text-base font-display font-bold tracking-widest uppercase" data-id="element-616">
                    {collection.model}
                  </p>
                </div>

                <div className="absolute inset-0 flex flex-col items-center justify-center text-white p-8 opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-617">
                  <h3 className="text-xl sm:text-2xl md:text-4xl font-display font-bold tracking-widest uppercase mb-4" data-id="element-618">
                    {collection.title}
                  </h3>
                  <div className="w-12 h-[1px] bg-white mb-4" data-id="element-619" />
                  <span className="text-xs font-display tracking-[0.3em] uppercase" data-id="element-620">
                    View Editorial
                  </span>
                </div>

                <div className="absolute bottom-6 left-6 right-6 flex justify-between items-end opacity-100 group-hover:opacity-0 transition-opacity duration-500" data-id="element-621">
                  <h3 className="text-white text-lg sm:text-xl md:text-2xl font-display font-bold tracking-widest uppercase drop-shadow-lg" data-id="element-622">
                    {collection.title}
                  </h3>
                  <span className="text-white text-xs font-display tracking-widest uppercase drop-shadow-lg" data-id="element-623">
                    {String(idx + 1).padStart(2, '0')} /{' '}
                    {String(lookbookCollections.length).padStart(2, '0')}
                  </span>
                </div>
              </motion.div>
            </Link>)}
        </div>
      </div>
    </div>;
}